import { createService } from '../../api/createService';
import {
  LoqateRetrieveRequestSchema,
  LoqateRetrieveResponseSchema,
} from './LoqateRetrieveService.schemas';

export default createService(
  {
    loqateRetrieve: {
      method: 'POST',
      url: () =>
        'https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      credentials: 'omit',
      requestSchema: LoqateRetrieveRequestSchema,
      responseSchema: LoqateRetrieveResponseSchema,
    },
  },
  undefined,
  false,
);
